import { Field, reduxForm } from 'redux-form'
import React, { PureComponent } from 'react'
import InputCheckboxSlider from '../../../commons/form/InputCheckboxSlider'
import { Button, Modal, Form } from 'react-bootstrap'
import InputSelect from '../../../commons/form/InputSelect'
import { handleKeyDown } from '../../../../util/utils'

class SubscriptionModal extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      organizedUnitIds: [],
      notificationEventId: null
    }
    this.onHandleOrganizedUnitsChange = this.onHandleOrganizedUnitsChange.bind(this)
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal) {
      const subscription = this.props.eventSubscription
      const OusArray = (subscription?.organizedUnitIds?.split(',')?.map(Number)) ?? []
      this.props.initialize({
        ...subscription,
        languageId: (subscription?.languageId ?? this.props.defaultLanguageId),
        active: subscription?.active ?? true,
        organizedUnitIds: OusArray
      })
      this.setState({ organizedUnitIds: subscription?.organizedUnitIds, notificationEventId: subscription?.notificationEventId })
      this.props.actions.fetchEventsCombo(this.props.userId, OusArray)
    }
    return null
  }

  componentDidUpdate (prevProps, prevState) {
  }

  saveEventSubscription (values) {
    new Promise((resolve, reject) => {
      return this.props.actions.saveEventSubscriptionFromAdmin(this.props.eventSubscription?.subscriptionId, values, this.props.userId, resolve, reject)
    }).then(() => {
      this.props.actions.closeModal()
    })
  }

  getFilteredComo () {
    return this.props.combos.events?.filter(x => x.notificationEventId === this.state.notificationEventId ||
      !this.props.subscribedEvents?.some(y => y === x.notificationEventId)) ?? []
  }

  onHandleOrganizedUnitsChange (value) {
    this.setState({ organizedUnitIds: value })
    this.props.actions.fetchEventsCombo(this.props.userId, value?.map(Number))
  }

  render () {
    const tKey = 'ADMIN.SUBSCRIPTIONS.EVENT_MODAL.'
    const {
      t, handleSubmit, showModal,
      combos: { lowestOrganizedUnitsCombo, languages },
      actions: { closeModal }
    } = this.props
    return (
      <Modal id="subscriptionModal" show={showModal} onHide={closeModal} className="_nf eventSubscriptionModal" backdrop={'static'} >
        <Modal.Header closeButton>
          <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
        </Modal.Header>
        <Form autoComplete="off" onSubmit={handleSubmit(this.saveEventSubscription.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                name="organizedUnitIds"
                id="organizedUnitIds"
                placeholder={t(`${tKey}OU`)}
                controlLabel={t(`${tKey}OU`)}
                multi={true}
                onInputChange={this.onHandleOrganizedUnitsChange}
                value = {this.state.organizedUnitIds}
                options={lowestOrganizedUnitsCombo}
                valueKey="id"
                labelKey="value"
              />
              <Field
                component={InputSelect}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                id="notificationEventId"
                name="notificationEventId"
                placeholder={t(`${tKey}EVENT`)}
                controlLabel={t(tKey + 'EVENT')}
                options={this.getFilteredComo()}
                valueKey="notificationEventId"
                labelKey="name"
                disabled= {(this.state.organizedUnitIds?.length ?? 0) === 0}
              />
              <Field
                component={InputSelect}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                id="languageId"
                name="languageId"
                placeholder={t(tKey + 'LANGUAGE')}
                controlLabel={t(tKey + 'LANGUAGE')}
                options={languages}
                valueKey="languageId"
                labelKey="description"
              />
              <Field
                component={InputCheckboxSlider}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                id="active"
                name="active"
                placeholder={t(`${tKey}ENABLE_ACTION`)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className='flexInLine al-C'>
            <Button type="submit" className="_Btn accept" disabled= {this.props.pristine}>{t('GLOBAL.BUTTONS.OK')}</Button>
            <Button id="cancelBtn" name="cancelBtn" onClick={closeModal} className="_Btn cancel">{t('GLOBAL.BUTTONS.CANCEL')}</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    )
  }
}

const validate = (values, props) => {
  const error = { }

  if (!values.organizedUnitIds || values.organizedUnitIds.length === 0) {
    error.organizedUnitIds = props.t('GLOBAL.FORMS.REQUIRED')
  }
  if (!values.notificationEventId) {
    error.notificationEventId = props.t('GLOBAL.FORMS.REQUIRED')
  }
  if (!values.languageId) {
    error.languageId = props.t('GLOBAL.FORMS.REQUIRED')
  }

  return Object.keys(error).length > 0 ? error : {}
}

export default reduxForm({
  form: 'subscriptionModal',
  destroyOnUnmount: true,
  validate
})(SubscriptionModal)
